const SHARED = {
    containerID: 'adminapp-toast',
    container: null, // The shared container element that will contain the individual toasts.
    options: {
        timeout: 4000,
        fadeout: 500,
        color: '#fff',
        background: '#666',
        boxShadow: '0 0.1em 0.2em #ccc'
    }
};

const STYLES =
`#${SHARED.containerID} {
    position: absolute;
    right: 0;
    bottom: 0;
    margin-right: 0.5em;
    margin-bottom: 0.5em;
}
#${SHARED.containerID} .block {
    text-align: right;
    cursor:pointer;
}
#${SHARED.containerID} .toast {
    display: inline-block;
    margin-top: 0.5em;
    padding: 0.5em 0.8em;
    text-align: left;
    cursor:pointer;

    opacity: 1;

    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -ms-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
    transition: opacity 1s ease-in-out;
}
#${SHARED.containerID} .toast.hide {
    opacity: 0;
}`;

function _getContainer() {
    if (SHARED.container || (SHARED.container = document.getElementById(SHARED.containerID)))
        return SHARED.container;

    const style = document.createElement('style');
    style.appendChild(document.createTextNode(STYLES));
    document.head.appendChild(style);

    SHARED.container = document.createElement('div');
    SHARED.container.id = SHARED.containerID;
    document.body.appendChild(SHARED.container);

    return SHARED.container;
}

function _addToast(msg, opts) {
    const eleContainer = _getContainer();

    const eleBlock = document.createElement('div');
    const eleToast = document.createElement('div');

    eleBlock.classList.add('block');
    eleToast.classList.add('toast');

    eleToast.style = `color: ${opts.color}; background: ${opts.background}; box-shadow: ${opts.boxShadow};`;
    eleToast.innerText = msg; // innerText will translate \n to <br>, vs textContent

    eleBlock.appendChild(eleToast);
    eleContainer.appendChild(eleBlock);

    //Auto Close
    setTimeout(_ => {
        if (eleBlock) {
            eleToast.classList.add('hide');
            setTimeout(_ => { eleBlock.remove(); }, opts.fadeout);
        }        
    }, opts.timeout);

    //Click to close
    eleBlock.addEventListener('click', function () {
        if (eleBlock) {
            eleToast.classList.add('hide');
            setTimeout(_ => { eleBlock.remove(); }, opts.fadeout);
        }
    });
}

/** lag-toast
 * Simple "toast" utility that provides the ability to showing non-intrusive messages that auto disappear after short period of time.
 *
 * EXAMPLE USAGE:
 *      toast.show('your message'); // uses default background and timeout
 *      toast.show('something', { background: '#666', timeout: 1000 });
 *      toast.show('blah blah', { timeout: 5000 }); // uses default background, etc
 *      toast.defaults({ background: '#666', timeout: 4000 });
 */
export const toast = {
    show(msg, opts) {
        if (!msg || !msg.length)
            throw new Error('lag.utility.toast{no msg}');

        opts = { ...SHARED.options, ...opts };

        _addToast(msg, opts);
    },

    defaults(opts) {
        if (!opts)
            throw new Error('lag.utility.toast{no opts}');

        for (const key in SHARED.options) {
            const val = opts[key];
            if (val) SHARED.options[key] = val;
        }
    }
};